var AuthIntegrationAction = /*#__PURE__*/function (AuthIntegrationAction) {
  AuthIntegrationAction["RefreshToken"] = "refreshToken";
  return AuthIntegrationAction;
}({});

var AuthIntegrationEvent = /*#__PURE__*/function (AuthIntegrationEvent) {
  AuthIntegrationEvent["ApiRequest"] = "onApiRequest";
  AuthIntegrationEvent["Authenticate"] = "onAuthenticate";
  AuthIntegrationEvent["Deauthenticate"] = "onDeauthenticate";
  AuthIntegrationEvent["Authenticated"] = "onAuthenticated";
  AuthIntegrationEvent["Deauthenticated"] = "onDeauthenticated";
  AuthIntegrationEvent["MapAuthenticatedState"] = "onMapAuthenticatedState";
  AuthIntegrationEvent["MapDeauthenticatedState"] = "onMapDeauthenticatedState";
  AuthIntegrationEvent["Reauthenticate"] = "onReauthenticate";
  AuthIntegrationEvent["Restore"] = "onRestore";
  AuthIntegrationEvent["Refresh"] = "onRefresh";
  return AuthIntegrationEvent;
}({});

export { AuthIntegrationAction, AuthIntegrationEvent };
